/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckboxModule } from '@dm/ang';
import { CoreModule } from '@dm/core';

import { ExportSimpleComponent } from '../export-simple/export-simple.component';
import { LogLabelAndBtnComponent } from '../log-label-and-btn/log-label-and-btn.component';
import { SimpleTimeAndSizeComponent } from '../simple-time-and-size/simple-time-and-size.component';
import { ExportComponent } from './export.component';
import { ExportService } from './export.service';
import { ExportStrService } from './export-str.service';
import { StreamlineDiagnosticModule } from './streamline-dianostic/streamline-dianostic.module';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        FormsModule,
        CheckboxModule,
        ReactiveFormsModule,
        StreamlineDiagnosticModule,
    ],
    declarations: [
        ExportComponent,
        ExportSimpleComponent,
        SimpleTimeAndSizeComponent,
        LogLabelAndBtnComponent,
    ],
    providers: [
        ExportService,
        ExportStrService,
    ],
    exports: [ExportComponent, ExportSimpleComponent],
})
export class ExportModule { }
